"use client";

import { Collapse, Typography } from 'antd';
import type { CollapseProps } from 'antd';
import { reportInofOrError, LoggerTitleTypeEnum } from "@/utils/tools"
import './index.css'

const { Text } = Typography;

import { warrantyRangeMapping, warrantyFlagMapping } from "@/utils/const";

import { ProductProps, SKUProps } from "@/types/index";
import { isMobile } from 'react-device-detect';

export type ProductPriceProps = {
  productData: ProductProps
  currentSku: SKUProps
};

export const CollapseComponent: React.FC<ProductPriceProps> = ({
  productData,
  currentSku,
  ...props
}) => {
  const productAttribute = productData.productAttribute
  
  let items1: CollapseProps['items'] = []
  let items2: CollapseProps['items'] = []
  let items3: CollapseProps['items'] = []
  let items4: CollapseProps['items'] = []
  try {

    items1 = [{
      key: '1',
      label: <h2 >Description</h2>,
      children: <div 
        style={{ wordBreak: 'break-word' }} 
        className={`flex flex-col gap-12 flex-wrap pb-24 whitespace-pre-line leading-24 text-lg`}
      >
        <div dangerouslySetInnerHTML={{ __html: productData.description }} suppressHydrationWarning></div>
      </div>
    }]

    items2 = productData?.installationInstructionAddress?.length ? [{
      key: '2',
      label: <h2>Installation Manual</h2>,
      children: <div className='pb-6'>
        {
          productData?.installationInstructionAddress && productData.installationInstructionAddress.map((item, index) => {
            return (
              <div key={index} className='flex items-center mb-18'>
                <iconpark-icon name="PDF" size="2.8rem" icon-id='PDF'></iconpark-icon>
                <Text underline className=' cursor-pointer select-none ml-6'>
                  <a href={process.env.NEXT_PUBLIC_IMAGE_URL + item.url} target="_blank" className="text-bravve-100 text-[1.6rem]">{item.name}</a>
                </Text>
              </div>
            )
          })
        }
      </div>
    }] : []

    items3 = [{
      key: '3',
      label: <h2>Specifications</h2>,
      children: <div className='pb-24 Specifications'>
        <div className='text-[1.8rem] font-bold mb-12'>Details</div>
        {
          Object.keys(productAttribute).map((key, index) => {
            const value = productAttribute[key as keyof typeof productAttribute]
            return (
              <div key={index} className={'flex justify-between items-center py-12 px-10 text-[1.6rem]' + (index % 2 === 1 ? '' : ' bg-bravve-bg-200')}>
                <span className='font-medium'>{key.replace("pas--", "")}</span>
                <span className='text-right'>{Array.isArray(value) ? ((value as []).length > 1 ? value[(value as []).length - 1] : value) : value}</span>
              </div>
            )
          })
        }
        <div className='text-[1.8rem] font-bold mt-20 mb-12'>Other Dimensions</div>
        <div className='text-[1.6rem] tr-td-transparent' dangerouslySetInnerHTML={{ __html: currentSku.measurementDescription }}></div>
      </div>
    }]

    items4 = [
      {
        key: '4',
        label: <h2>Warranty</h2>,
        children: <div className='pb-24'>
          <div className='flex justify-between items-center py-12 px-10 text-[1.6rem]'>
            <span className='font-medium'>Product Warranty</span>
            <span className='text-right'>{warrantyFlagMapping[productData.warrantyFlag as keyof typeof warrantyFlagMapping]}</span>
          </div>
          {
            productData.warrantyFlag === 'NOT_KEEP_UNDER_WARRANTY' ?
              null
              :
              <>
                <div className='flex justify-between items-center py-12 px-10 text-[1.6rem] bg-bravve-bg-200'>
                  <span className='font-medium'>Warranty Duration</span>
                  <span className='text-right'>{productData.warrantyYear} Months</span>
                </div>
                {
                  productData.warrantyRange &&
                  <div className='flex justify-between items-center py-12 px-10 text-[1.6rem]'>
                    <span className='font-medium'>Full or Limited Warranty</span>
                    <span className='text-right'>{warrantyRangeMapping[productData.warrantyRange as keyof typeof warrantyRangeMapping]}</span>
                  </div>
                }
              </>
          }

        </div>
      }
    ]

  } catch (error) {
    // if (!isProduction) {
    //   const log = new Logger();
    //   // 将 error 转换为符合 log.error 参数类型的对象
    let errorData: { [key: string]: any } | undefined;

    if (error instanceof Error) {
      // 如果 error 是 Error 实例，提取 message 和 stack
      errorData = {
        message: error.message,
        stack: error.stack
      };
    } else {
      // 如果 error 不是 Error 实例，尝试将其转换为字符串
      errorData = {
        message: String(error)
      };
    }
    // 上报日志
    reportInofOrError({
      title: LoggerTitleTypeEnum.ClientTryCatchRrror,
      type: "error",
      data: {
        message: "CollapseComponent",
        data: {
          url: window.location.href,
          ...errorData
        }
      }
    })
  }

  return <Collapse
    defaultActiveKey={['1']}
    expandIcon={(panelProps) => panelProps.isActive ?
      <iconpark-icon size={'2rem'} name="minus" icon-id='minus' color='#796B64'></iconpark-icon>
      :
      <iconpark-icon size={'2rem'} name="plus" icon-id='plus' color='#796B64'></iconpark-icon>
    }
    ghost
    items={[...items1, ...items2, ...items3, ...items4]}
    className='ProductCollapse'
  />
}